var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBathrooms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bathrooms_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M5.645 16.235V4.233a3.53 3.53 0 1 1 7.06 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  d: "M9.178 7.764v-.706a3.53 3.53 0 0 1 3.527-3.527 3.53 3.53 0 0 1 3.527 3.527v.706z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9.881,
  cy: 10.586,
  r: 0.703,
  fill: "#6E3037"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.705,
  cy: 10.586,
  r: 0.703,
  fill: "#6E3037"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.529,
  cy: 10.586,
  r: 0.703,
  fill: "#6E3037"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11.293,
  cy: 13.41,
  r: 0.703,
  fill: "#6E3037"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.117,
  cy: 13.41,
  r: 0.703,
  fill: "#6E3037"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.705,
  cy: 16.234,
  r: 0.703,
  fill: "#6E3037"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M8.469 7.762h8.472"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  d: "m32.802 24.707-.668 5.008a3.18 3.18 0 0 1-2.636 2.717c-.323.052 1.169.041-22.484.041a3.18 3.18 0 0 1-3.149-2.758l-.668-5.008h16.567v2.824c0 .78.632 1.412 1.412 1.412h4.237c.78 0 1.411-.633 1.411-1.412v-2.824z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m33.178 21.883-1.044 7.833a3.18 3.18 0 0 1-3.149 2.757H7.014a3.18 3.18 0 0 1-3.149-2.757L2.82 21.883M10.586 32.473l-.706 2.823H7.057v-2.823M29.649 32.473v2.823h-2.824l-.706-2.823"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M26.825 21.882h7.06a1.412 1.412 0 1 0 0-2.823H2.115c-.39 0-.742.158-.998.414-.882.881-.263 2.41.998 2.41h17.65"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M4.232 19.058v-1.412a1.412 1.412 0 0 1 2.825 0v1.412M26.826 19.059v8.471c0 .78-.632 1.412-1.412 1.412h-4.237c-.78 0-1.411-.632-1.411-1.412V19.06M26.826 26.117h-7.06"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bathrooms_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
})))));
export default SvgBathrooms;